import React from "react";
import { IntegerInput } from "components/Global/FormikMaterial";
import { SecondaryButton } from "components/Global/Buttons";
import "./cloneValuesInputButtonStyles.css";

const CloneValuesInputButton = ({ values: formikValues, setFieldValue, handleClonePress, disabled }) => (
  <div className="clone-values-wrapper">
    <IntegerInput
      value={formikValues.companyIdToClone}
      onChange={e => setFieldValue("companyIdToClone", e.target.value)}
    />
    <SecondaryButton
      disabled={disabled}
      style={{ cursor: "pointer", backgroundColor: "rgba(0,0,0,0)", border: "none", paddingTop: "2px" }}
      onClick={handleClonePress}
    >
      Set Default Values
    </SecondaryButton>
  </div>
);

export default CloneValuesInputButton;
